
import React, { useState } from 'react';
import './footer.css';
import { Link } from 'react-router-dom';
import newLogo from '../../images/white-logo.png';
import { AiFillFacebook } from 'react-icons/ai';
import { BsTwitter } from 'react-icons/bs';
import { AiFillYoutube } from 'react-icons/ai';
import { AiFillInstagram } from 'react-icons/ai';


const FooterMob = () => {

    


    



    return (


        <>
            <div className="footer footer-sm">
                <div className="container-fluid p-0 overflow-hidden">
                    <div style={{ background: '#05A474' }} className="justify-content-center py-5 row">
                        <div className="col-md-7 ">
                            <h5 className='subs'>Get our experts to answer your questions within 24 Hrs</h5>
                            <div className="search">
                                <input type="text" placeholder="Example.com" />
                                <span>
                                    send
                                </span>
                            </div>
                        </div>
                    </div> {/*  1st row end */}
                     
                    <div className="footer-bottom-sm   pb-4" style={{ background: 'rgba(0, 102, 71, 1)', color: 'rgb(255, 255, 255, 0.7)'}}>
                        <div className=""><img src={newLogo} alt="footer-logo" /></div>
                        <div className="container px-3">
                            <p className="">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad litora torquent per conubia nostra.</p>
                            <h5 className="">Email Us</h5>
                            <p className="fw-light">Obelabs@gmail.om</p>
                            <div className="">
                            <h5 className="mt-4">Important Links</h5>
                            <div className="bg-white pt-1 rounded-3 mt-3 mb-4" ></div>
                            <div className="imp-link mt-3 mb-5 pb-3">
                                
                                <p className="fw-light">Best coaching for upsc</p>
                                <p className="fw-light">How to find a good coaching ?</p>
                                <p className="fw-light">How to spot a top IAS institute ?</p>
                                <p className="fw-light">Best coaching for upsc</p>
                                <p className="fw-light">How to find a good coaching ?</p>
                                <p className="fw-light">How to spot a top IAS institute ?</p>
                                <p className="fw-light">Best coaching for upsc</p>
                                <p className="fw-light">How to find a good coaching ?</p>
                                <p className="fw-light">How to spot a top IAS institute ?</p>
                                <p className="fw-light">Best coaching for upsc</p>
                            </div>
                            </div>
                        </div>
                        <div className="">
                            <div className=" text-center">
                                <p className="">@ copyright 2022 All right reserved</p>
                                <p className=" d-flex justify-content-center align-items-center">
                                    <Link className='nav-link' to={'/'}>Home</Link>
                                    <span className=' d-block mx-3 bg-light' style={{padding: "10px 0.5px 10px 0px"}}></span>
                                    <Link className='nav-link' to={"/"}>About Us</Link>
                                    <span className=' d-block mx-3 bg-light' style={{padding: "10px 0.5px 10px 0px"}}></span>
                                    <Link className='nav-link' to={"/"}>Contact Us</Link>
                                </p>
                                <p className='d-flex gap-5 justify-content-center'>
                                    <span><AiFillFacebook className='fs-3'/></span>
                                    <span><BsTwitter className='fs-3' /></span>
                                    <span><AiFillYoutube className='fs-3' /></span>
                                    <span><AiFillInstagram className='fs-3' /></span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>


    )
}

export default FooterMob